import { PhysicalThing } from "../physicalThing";
import type { XY } from "../xy";
import { ZOrder } from "../zOrder";

export class DevGunAutoKillBotProjectile extends PhysicalThing {
	static key = "DevGunAutoKillBotProjectile";
	constructor(xy: XY) {
		super(xy, false);
	}

	override getZOrder(): number {
		return ZOrder.AIR;
	}
}
